import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, EventEmitter, OnInit, Output, NgZone } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDividerModule } from "@angular/material/divider";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { SolProductPromotionDialog } from "../../menu/tools-menu/sol-product-promotion/sol-product-promotion.component";
import { SolSubsidyProgramComponent } from "../../menu/tools-menu/sol-subsidy-program/sol-subsidy-program.component";
import { SolPropertiesComponent } from "../../menu/file-menu/sol-properties/sol-properties.component";
import { CONSTANTS } from "../../../Constants/Constants";
import { FileMenu, LIBRARY_TABS, MenuItems, ProjectTabs, PropertyOptionId, ToolsMenu, ViewMenu, WindowsMenus } from "../../../models/enum";
import { ExportProposalDialogComponent } from "../../dialogs/common/export-proposal-dialog/export-proposal-dialog.component";
import { RecentAndFavEstimateComponent } from "../recent-and-fav-estimate/recent-and-fav-estimate.component";
import { SolPreferencesComponent } from "../../menu/edit-menu/sol-preferences/sol-preferences.component";
import { CommonFunctionsService } from "../../../services/common-functions.service";
import { EstimateCloseService } from '../../../services/estimate-close.service';
import { EstimateSaveService } from '../../../services/estimate-save.service';
import { CollaborationOperationsService } from '../../../services/common/collaboration-operations.service';
import { TurnoverToSalesDialog } from '../../dialogs/common/turnover-to-sales-dialog/turnover-to-sales-dialog';
import { CostReviewFunctionsService } from '../../../services/review/cost-review-functions.service';
import { SyncOperationsService } from '../../../services/common/sync-operations.service';
import { PreferencesService } from '../../../services/preferences/preferences.service';
import { CollaborationState, EstimateStatus, EstimateTypes, GetUserPreferencesResponse, Preferences } from "../../../models/dtos";
import { MaterialIndicatorComponent } from "../../menu/material-indicator/material-indicator.component";
import { CommonDataService } from "../../../services/common-data.service";
import { OpenEstimateComponent } from "../../dialogs/common/open-estimate/open-estimate.component";
import { CustomerInformationDialogComponent } from "../../dialogs/common/customer-information-dialog/customer-information-dialog.component";
import { firstValueFrom, Subject } from "rxjs";
import { takeUntil, take } from "rxjs/operators";
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SapSubmittalRequestDialogComponent } from "../../dialogs/common/sap-submittal/sap-submittal-request-dialog/sap-submittal-request-dialog.component";
import { SolMaterialCheckerDialogComponent } from "../../dialogs/sol/sol-material-checker-dialog/sol-material-checker-dialog.component";
import { WorkspaceMenuComponent } from "../../menu/workspace-menu/workspace-menu.component";
import { NavBarService } from "../../../services/nav-bar.service";
import { UserProfileService } from '../../../services/common/user-profile.service';
import { LanguageSettingComponent } from "../../dialogs/common/language-setting/language-setting.component";
import { MatTooltip } from "@angular/material/tooltip";
import { CommonMetaDataService } from "../../../services/common-meta-data.service";
import { UnlockSubmittedEstimateDialogComponent } from "../../dialogs/common/sap-submittal/unlock-submitted-estimate-dialog/unlock-submitted-estimate-dialog.component";
import { SaveConfirmationDialogComponent } from "../../dialogs/common/save-confirmation-dialog/save-confirmation-dialog.component";
import { FileOpportunityComponent } from "../../menu/file-menu/file-opportunity/file-opportunity.component";
import { GocCollaborationRestrictionHandlerService } from "../../../services/common/goc-collaboration-restriction-handler.service";
import { UnsavedChangesService } from "../../../services/common/unsaved-changes.service";


@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss'],
  imports: [
    CommonModule,
    MatListModule,
    MatMenuModule,
    MatButtonModule,
    MatChipsModule,
    MatTooltipModule,
    MatIconModule,
    MatDividerModule,
    TranslatePipe,
    SolProductPromotionDialog,
    SolPropertiesComponent,
    ExportProposalDialogComponent,
    RecentAndFavEstimateComponent,
    SolPreferencesComponent,
    MaterialIndicatorComponent,
    OpenEstimateComponent,
    CustomerInformationDialogComponent,
    MatDialogModule,
    SapSubmittalRequestDialogComponent,
    SolMaterialCheckerDialogComponent,
    WorkspaceMenuComponent,
    SolSubsidyProgramComponent,
    LanguageSettingComponent,
    MatTooltip,
    FileOpportunityComponent
  ],
  standalone: true
})
export class SideNavBarComponent implements OnInit, OnDestroy {

  @Output() closeSidenav = new EventEmitter<void>();
  @Input() selectedTabIndex: number = ProjectTabs.Estimate;

  propertiesOptionId = PropertyOptionId;
  selectedMainItem: string = CONSTANTS.EMPTY_STRING;
  selectedSubOption: string = CONSTANTS.EMPTY_STRING;
  selectedOption: string = CONSTANTS.EMPTY_STRING;
  secondDrawerTitle: string = CONSTANTS.EMPTY_STRING;
  selectedContentTitle: string = CONSTANTS.EMPTY_STRING;
  preferencesObject: Preferences = new Preferences();
  @Output() saveCurrentWorkspaceEvent = new EventEmitter<void>();
  @Output() resetCurrentWorkspaceEvent = new EventEmitter<void>();
  @Output() resetFactoryWorkspaceEvent = new EventEmitter<void>();
  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Output() toggleLibraryEvent = new EventEmitter<number>();
  @Output() navigateToEstimateTabEvent = new EventEmitter<void>();
  @Output() navigateToEstimateTabWithoutCloseEvent = new EventEmitter<void>();
  @Output() setDefaultEstimateId = new EventEmitter<void>();
  isPropertiesDisabled: boolean = false;
  private readonly destroy$ = new Subject<void>();

  SOLUTION_LIBRARY_ITEMS = {
    PreviewView: 'Preview View',
    ProjectView: 'Project View',
    CostSummaryView: 'Cost Summary View',
    LibraryView: 'Library View'
  }

  backdropVisible: boolean = false;
  panelsVisible: boolean = false;
  isSapSubmitted: boolean = false;
  isLoggingOut: boolean = false;

  constructor(
    private readonly translate: TranslateService,
    private readonly commonDataService: CommonDataService,
    private readonly commonFunctionsService: CommonFunctionsService,
    private readonly estimateCloseOperationsService: EstimateCloseService,
    private readonly estimateSaveService: EstimateSaveService,
    private readonly collaborationOperationsService: CollaborationOperationsService,
    private readonly costReviewOperationsService: CostReviewFunctionsService,
    private readonly syncOperationsService: SyncOperationsService,
    private readonly preferencesService: PreferencesService,
    public navBarService: NavBarService,
    public userProfileService: UserProfileService,
    public metadataService: CommonMetaDataService,
    private readonly gocCollaborationRestrictionHandlerService: GocCollaborationRestrictionHandlerService,
    private readonly unsavedChangesService: UnsavedChangesService,
    public readonly dialog: MatDialog,
    private readonly ngZone: NgZone
  ) { }

  ngOnInit() {
    this.checkUserPreferences();
    this.subscribeToReadOnlyMode();
    this.getUserDetails();
    requestAnimationFrame(() => {
      this.backdropVisible = true;
      this.panelsVisible = true;
    });
    this.commonDataService.isSapSubmitted$.pipe(takeUntil(this.destroy$)).subscribe(isSapSubmitted => {
      if (isSapSubmitted && this.selectedOption === `${MenuItems.file}_${FileMenu.SAP_submittal}`) {
        this.clearSelection();
      }
      this.isSapSubmitted = isSapSubmitted;
    });
  }

  subscribeToReadOnlyMode() {
    this.commonDataService.readOnlyMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isReadOnly) => {

        if (this.isPropertiesOptionDisabled() && this.selectedOption === `${MenuItems.file}_${FileMenu.properties}`) {
          this.clearSelection();
        }
      });
  }


  checkUserPreferences() {
    const userPreferencesData: GetUserPreferencesResponse = this.commonDataService.getPreferenceData();
    if (userPreferencesData && userPreferencesData.preferences) {
      this.preferencesObject = userPreferencesData.preferences;
    }
  }

  async openSecondDrawer(mainItem: string): Promise<void> {
    // Switching menus tears down the open Properties/Preferences panel.
    if (!await this.unsavedChangesService.confirmLeave()) {
      return;
    }
    this.selectedMainItem = mainItem;
    this.selectedOption = CONSTANTS.EMPTY_STRING;
    this.selectedSubOption = CONSTANTS.EMPTY_STRING;
    this.getSecondDrawerTitle();
  }

  async closeSecondDrawer(): Promise<void> {
    if (!await this.unsavedChangesService.confirmLeave()) {
      return;
    }
    this.selectedMainItem = CONSTANTS.EMPTY_STRING;
    this.selectedOption = CONSTANTS.EMPTY_STRING;
    this.selectedSubOption = CONSTANTS.EMPTY_STRING;
  }

  async onBackdropClick(): Promise<void> {
    if (await this.unsavedChangesService.confirmLeave()) {
      this.closeSidenav.emit();
    }
  }

  async selectOption(mainItem: string, subOption: string, isDisable?: boolean) {
    if (isDisable) {
      return;
    }
    switch (subOption) {
      case FileMenu.close:
        {
          const canClose = await this.handleUnsavedChanges();
          if (!canClose) {
            return;
          }

          this.setDefaultEstimateId.emit();
          this.costReviewOperationsService.resetLibrarySaveState();
          await this.estimateCloseOperationsService.closeEstimate();
          this.commonDataService.isSaveEnabled = false;
          this.clearSelection();
          this.closeSidenav.emit();
          return;
        }
      case FileMenu.properties:
        if (this.isPropertiesOptionDisabled()) {
          return;
        }
        break;
      case FileMenu.save: {
        await this.estimateSaveService.save();
        const estimateId = this.commonDataService.getEstimateId();
        const estimateName = this.commonDataService.getEstimateData()?.estimateName || "";
        this.preferencesService.addToRecentViewedEstimateList(estimateId, estimateName);
        this.commonDataService.isSaveEnabled = false;
        this.costReviewOperationsService.resetLibrarySaveState();
      }
        return;
      case FileMenu.exit:
        // TO-DO: Implement logic.
        return;
      case ViewMenu.colorSymbols:
        this.preferencesObject.showColorReport = !this.preferencesObject.showColorReport;
        this.commonDataService.setColorSymbolsMode(this.preferencesObject.showColorReport);
        this.preferencesService.saveUserPreferenceData(this.preferencesObject);
        return;
      case ViewMenu.showInputOutput:
        this.preferencesObject.showIO = !this.preferencesObject.showIO;
        this.commonDataService.setShowInputOutputMode(this.preferencesObject.showIO);
        this.preferencesService.saveUserPreferenceData(this.preferencesObject);
        return;
      case ToolsMenu.synchronizationData:
        this.syncOperationsService.synchronizeData();
        return;
      case FileMenu.Turnover_to_Sales:
        this.clearSelection();
        await this.turnOverToSales();
        return;
      case FileMenu.SAP_submittal:
        {
          if (this.isSapSubmitted) {
            this.dialog.open(UnlockSubmittedEstimateDialogComponent, {
              height: '300px',
              disableClose: true
            });
            return;
          }
        }
    }

    // Opening a different panel replaces the current one (e.g. Properties/Preferences).
    const nextOption = `${mainItem}_${subOption}`;
    if (this.selectedOption && this.selectedOption !== nextOption
      && !await this.unsavedChangesService.confirmLeave()) {
      return;
    }

    this.selectedSubOption = subOption;
    this.selectedOption = `${mainItem}_${subOption}`;
    if (subOption === WindowsMenus.workspace) {
      this.selectedOption = CONSTANTS.EMPTY_STRING;
    } else {
      this.getSelectedOptionTitle(mainItem, subOption);
    }
  }

  getSecondDrawerTitle(): void {
    switch (this.selectedMainItem) {
      case MenuItems.file:
        this.secondDrawerTitle = this.translate.instant('MENU_FILE');
        break;
      case MenuItems.edit:
        this.secondDrawerTitle = this.translate.instant('MENU_EDIT');
        break;
      case MenuItems.view:
        this.secondDrawerTitle = this.translate.instant('SIDE_NAV_LIBRARY_VIEW');
        break;
      case MenuItems.tools:
        this.secondDrawerTitle = this.translate.instant('MENU_TOOLS');
        break;
      case MenuItems.window:
        this.secondDrawerTitle = this.translate.instant('MENU_WINDOW');
        break;
      case MenuItems.help:
        this.secondDrawerTitle = this.translate.instant('MENU_HELP');
        break;
      default:
        this.secondDrawerTitle = CONSTANTS.EMPTY_STRING;
        break;
    }
  }

  getSelectedOptionTitle(mainItem: string, subOption: string): void {
    switch (mainItem) {
      case 'file':
        this.getContentTitleFileMenu(subOption);
        break;
      case 'edit':
        this.getContentTitleEditMenu(subOption);
        break;
      case 'view':
        break;
      case 'tools':
        this.getContentTitleToolsMenu(subOption);
        break;
      case 'window':
        break;
      case 'help':
        this.getContentTitleHelpMenu(subOption);
        break;
      default:
        this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
        break;

    }
  }

  async getContentTitleFileMenu(subOption: string): Promise<void> {
    switch (subOption) {
      case FileMenu.properties:
        this.selectedContentTitle = CONSTANTS.EMPTY_STRING; // for Properties title is not needed as it's layout is different than others
        break;
      case FileMenu.open:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_OPEN');
        break;
      case FileMenu.opportunity:
        this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
        break;
      case FileMenu.export_proposal:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_EXPORT_TO_PROPOSAL');
        break;
      case FileMenu.recent:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_RECENT');
        break;
      case FileMenu.customer_information:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_CUSTOMER_INFORMATION');
        break;
      case FileMenu.SAP_submittal:
        this.selectedContentTitle = this.translate.instant('SAP_SUBMITTAL');
        break;
      default:
        this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
        break;
    }
  }

  getContentTitleEditMenu(subOption: string): void {
    this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
  }

  getContentTitleToolsMenu(subOption: string): void {
    switch (subOption) {
      case ToolsMenu.productPromotion:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_PRODUCT_PROMOTION');
        break;
      case ToolsMenu.subsidyProgram:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_SUBSIDY_PROGRAM');
        break;
      case ToolsMenu.material_checker:
        this.selectedContentTitle = this.translate.instant('TOOLS_MENU_MATERIAL_CHECKER');
        break;
      case ToolsMenu.displayLanguageSettings:
        this.selectedContentTitle = this.translate.instant('SIDE_NAV_DISPLAY_LANGUAGE_SETTINGS');
        break;
      case ToolsMenu.synchronizationData:
        this.selectedContentTitle = this.translate.instant('TOOLS_MENU_SYNCHRONIZATION_DATA');
        break;
      default:
        this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
        break;
    }
  }

  getContentTitleWindowMenu(subOption: string): void {
    if (subOption === WindowsMenus.workspace) {
      this.selectedContentTitle = this.translate.instant('SIDE_NAV_WORKSPACE');
    }
  }

  getContentTitleHelpMenu(subOption: string): void {
    // add cases for Help Menu options
  }


  clearSelection() {
    this.selectedOption = CONSTANTS.EMPTY_STRING;
    this.selectedSubOption = CONSTANTS.EMPTY_STRING;
  }

  onNavigateToProposalProperties() {
    this.selectedMainItem = MenuItems.file;
    this.selectedSubOption = FileMenu.properties;
    this.selectedOption = `${MenuItems.file}_${FileMenu.properties}_proposal`;
    this.selectedContentTitle = CONSTANTS.EMPTY_STRING;
    this.getSecondDrawerTitle();
  }

  onNavigateToEstimateTab() {
    this.clearSelection();
    this.closeSidenav.emit();
    this.navigateToEstimateTabEvent.emit();
  }

  onNavigateToEstimateThenProposalProperties() {
    this.navigateToEstimateTabWithoutCloseEvent.emit();
    this.ngZone.onStable.pipe(
      take(CONSTANTS.ONE),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.onNavigateToProposalProperties();
    });
  }

  openLibrary(key: string) {
    let libraryTab = -1;
    switch (key) {
      case this.SOLUTION_LIBRARY_ITEMS.PreviewView:
        libraryTab = LIBRARY_TABS.Preview;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.ProjectView:
        libraryTab = LIBRARY_TABS.ProjectView;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.CostSummaryView:
        libraryTab = LIBRARY_TABS.CostSummaryView;
        break;
      case this.SOLUTION_LIBRARY_ITEMS.LibraryView:
        libraryTab = LIBRARY_TABS.LibraryView;
        break;
      default:
        break;
    }
    if (libraryTab >= 0) {
      this.toggleLibraryEvent.emit(libraryTab);
    }
    this.closeDrawerEvent.emit();
  }

  saveCurrentWorkspace() {
    this.saveCurrentWorkspaceEvent.emit();
  }
  resetCurrentWorkspace() {
    this.resetCurrentWorkspaceEvent.emit();
  }
  resetFactoryWorkspace() {
    this.resetFactoryWorkspaceEvent.emit();
  }

  isEstimateOpen(): boolean {
    return (this.commonDataService.getEstimateId() !== CONSTANTS.DEFAULT_ESTIMATE_ID);
  }

  enableDrawerOption(): boolean {
    const activeTab = this.commonDataService.getActiveTab();
    return ((this.commonDataService.getEstimateId() !== CONSTANTS.DEFAULT_ESTIMATE_ID) && (activeTab !== ProjectTabs.Reports));
  }

  isExportToProposalDisabled(): boolean {
    return this.commonDataService.getEstimateId() === CONSTANTS.DEFAULT_ESTIMATE_ID
      || this.commonDataService.getRootNodeHidden()
      || (this.commonDataService.isCollaborationEstimate() && this.commonDataService.getCollaborationState() !== CollaborationState.Edit);
  }

  isPropertiesOptionDisabled(): boolean {
    return !this.isEstimateOpen() || this.selectedTabIndex === ProjectTabs.Reports || this.selectedTabIndex === ProjectTabs.Review;
  }

  isSapSubmittalOptionDisabled(): boolean {
    return !this.isEstimateOpen() || (this.isReadonlyMode() && !this.isSapSubmitted);
  }

  hasChanges(): boolean {
    return this.commonDataService.isSaveEnabled;
  }

  isReadonlyMode(): boolean {
    return this.commonDataService.isReadOnlyMode();
  }

  async logout() {
    if (this.isLoggingOut) {
      return;
    }
    this.isLoggingOut = true;

    try {
      // close estimate then logout
      const canClose = await this.handleUnsavedChanges();
      if (!canClose) {
        return;
      }

      this.setDefaultEstimateId.emit();
      this.costReviewOperationsService.resetLibrarySaveState();
      await this.estimateCloseOperationsService.closeEstimate();

      this.commonFunctionsService.logout();
    } catch (error) {
      console.error("Error in logout: ", error);
    } finally {
      this.isLoggingOut = false;
    }

  }

  username: string = CONSTANTS.EMPTY_STRING;
  userDetailsTooltip: string = CONSTANTS.EMPTY_STRING;
  userEmail: string = CONSTANTS.EMPTY_STRING;
  userInitials: string = CONSTANTS.EMPTY_STRING;

  getUserDetails(): void {
    const userInfo = this.userProfileService.userInfo;

    this.username = userInfo?.display_name ?? CONSTANTS.EMPTY_STRING;
    this.userEmail = userInfo?.mail ?? CONSTANTS.EMPTY_STRING;
    this.userInitials = this.username
      .split(/[\s,]+/)
      .filter((part) => !!part)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');

    this.userDetailsTooltip = [
      this.username,
      userInfo?.mail ?? CONSTANTS.EMPTY_STRING,
      userInfo?.gid ?? CONSTANTS.EMPTY_STRING,
    ]
      .filter((value) => !!value)
      .join('\n');
  }
  get isEstimateSapSubmitted(): boolean {
    const estimateData = this.commonDataService.getEstimateData();
    if (estimateData && estimateData.estimateStatusId === EstimateStatus.Submitted) {
      return true;
    }
    return false;
  }

  get isCreateOppDisabled(): boolean {
    const estimateData = this.commonDataService.getEstimateData();
    if (estimateData && estimateData.estimateStatusId === EstimateStatus.Submitted) {
      return true;
    }
    const estimateMetaData = this.commonDataService.getEstimateMetaData();
    return !!estimateMetaData?.estimateSettings.opportunityId;
  }

  get isReadOnlyCollaborativeEstimate(): boolean {
    const estimateData = this.commonDataService.getEstimateData();
    return !!estimateData
      && estimateData.estimateStatusId !== EstimateStatus.Submitted
      && this.commonDataService.isCollaborationEstimate()
      && this.commonDataService.getCollaborationState() !== CollaborationState.Edit;
  }

  get isCRMDisabled(): boolean {
    const estimateData = this.commonDataService.getEstimateData();
    if (!estimateData) {
      return false;
    }


    const isChangeOrderEstimate = estimateData.estimateTypeId === EstimateTypes.ChangeOrderEstimate;
    const isQuotedServiceEstimate = this.commonFunctionsService.isQuotedServiceEstimate();

    return isChangeOrderEstimate && isQuotedServiceEstimate;
  }

  isGocUser(): boolean {
    const userInfo = this.metadataService.getUserProfile();

    return this.isEstimateOpen() && userInfo?.zoneId === CONSTANTS.GOC_ZONE_ID;
  }

  canTurnoverToSales(): boolean {
    //!GeneralProjectSettings.IsReadOnlyCollaborativeEstimateOpen
    return this.commonDataService.isCollaborationEstimate() && (this.commonDataService.getCollaborationState() === CollaborationState.Edit);
  }

  get turnOverToSalesLabel(): string {
    const ttsDetails = this.commonDataService.getOtherMetaData()?.ttsDetails;
    if (!ttsDetails) {
      return 'TURNOVER_TO_SALES';
    }

    if (typeof ttsDetails.turnoverDateTime === 'string') {
      ttsDetails.turnoverDateTime = new Date(ttsDetails.turnoverDateTime);
    }

    return (!isNaN(ttsDetails.turnoverDateTime.getTime()) &&
      ttsDetails.turnoverDateTime.getFullYear() > CONSTANTS.ONE) ? 'TURNOVER_TO_SALES_UPDATE' : 'TURNOVER_TO_SALES';
  }

  private async turnOverToSales(): Promise<void> {
    const ttsDetails = this.commonDataService.getOtherMetaData()?.ttsDetails;
    if (!ttsDetails) {
      return;
    }
    const saveReq = await this.estimateSaveService.createSaveEstimateRequest();
    if (!isNaN(ttsDetails.turnoverDateTime.getTime()) &&
      ttsDetails.turnoverDateTime.getFullYear() > CONSTANTS.ONE) {
      const dialogRef = this.dialog.open(TurnoverToSalesDialog, {
        width: CONSTANTS.COLLABORATION_POPUP_WIDTH,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((modificationNotes: string) => {
        if (modificationNotes !== undefined) {
          this.collaborationOperationsService.turnoverToSales(
            modificationNotes,
            saveReq,
            (error: unknown) => this.gocCollaborationRestrictionHandlerService.isGocUserRestricted(error)
          );
        }
      });
    } else {
      this.collaborationOperationsService.turnoverToSales(
        this.translate.instant('TURNOVER_TO_SALES_DEFAULT_MODIFICATION_NOTES'),
        saveReq,
        (error: unknown) => this.gocCollaborationRestrictionHandlerService.isGocUserRestricted(error)
      );
    }
  }

  async handleUnsavedChanges(): Promise<boolean> {
    if (this.commonDataService.getCollaborationState() === CollaborationState.Edit) {
      if (!await this.estimateCloseOperationsService.collaborativeChecksBeforeClose(
        () => this.estimateSaveService.createSaveEstimateRequest())) {
        return false;
      }
      await this.estimateCloseOperationsService.closeEstimate();
      return true;
    }
    if (this.hasChanges() && !this.commonDataService.isReadOnlyMode()) {
      const confirmationDialogRef = this.dialog.open(SaveConfirmationDialogComponent, {
        disableClose: true,
        data: { estimateName: this.commonDataService.getEstimateName() }
      });
      const okClicked = await firstValueFrom(confirmationDialogRef.afterClosed());
      if (okClicked === null || okClicked === undefined) {
        return false;
      }
      if (okClicked) {
        await this.estimateSaveService.save();
      }
    }

    return true;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}